export default __webpack_public_path__ + "static/media/singaporePool.4dd585ac.png";